import { ListStore, ListStoreProps } from '@/main/store/@types/list.d';
import { UPDATE_BASIC_FILTER } from '@/main/store/listEditTypes';
import { Status } from '@/main/store/@types/page';
import { dataMapper } from '@/main/utils/dataMapper';


import { types } from '../types';
import { Filter, ArchivDropdownList } from './state';

type State = ListStore<Filter, ArchivDropdownList, {}, null, ListStoreProps>;

type Data<T = {}> = { data: { value: number, text: string } & T };

export const mutations = {
	[types.mutations.ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.ZakaznikId = data.value;
		state.filter.ZakaznikIdText = data.text;
	},
	[types.mutations.ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER](state: State, { data }: Data<{ nr: number }>) {
		state.filter.OzakazkaId = data.value;
		state.filter.OzakazkaIdText = data.text;
		state.filter.OzakazkaIdNr = data.nr;
	},
	[types.mutations.ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.PojistovnaId = data.value;
		state.filter.PojistovnaIdText = data.text;
		state.filter.PojistovnaIdPrp = !data.value ? null : true;
	},
	[types.mutations.ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.LeaszakaznikId = data.value;
		state.filter.LeaszakaznikIdText = data.text;
		state.filter.LeaszakaznikIdPrp = !data.value ? null : true;
	},
	[types.mutations.ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.SmluvpartnerId = data.value;
		state.filter.SmluvpartnerIdText = data.text;
	},
	[types.mutations.ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER](state: State, { data }: Data) {
		state.filter.VstupPracId = data.value;
		state.filter.VstupPracIdText = data.text;
	},
	[UPDATE_BASIC_FILTER](state: State, data: any) {
		data.DropDownList
		&& (state.dropdownList = { ...state.dropdownList, ...data.DropDownList });
		dataMapper(state.filter, data.Filter);
		state.status = Status.ok;
		state.table.emptyTextKey = 'TableMsgRunSearch';
		state.filter.UzavrenePrp = true;
	},
};
